import { render, staticRenderFns } from "./CopyrightPolicy.vue?vue&type=template&id=d582e594&scoped=true&"
import script from "./CopyrightPolicy.vue?vue&type=script&lang=ts&"
export * from "./CopyrightPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CopyrightPolicy.vue?vue&type=style&index=0&id=d582e594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d582e594",
  null
  
)

export default component.exports